import React, { PropsWithChildren, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { ArrowRight } from '../../atoms/icons/ArrowRight';

import { parseSectionID } from '../../../utils/string-utils';

import mq from '../../../styles/breakpoints';
import { IntroText, ProductPageH2 } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import HorizontalScrollWrapper from '../horizontal-scroll-wrapper/HorizontalScrollWrapper';

interface Props extends PropsWithChildren {
  title: string;
  subtitle: string;
  type: string;
  children: ReactNode[];
  anchorName?: string;
}

const RowOfImagesWrapper = ({
  title,
  subtitle,
  type,
  children,
  anchorName,
}: Props) => {
  const id = parseSectionID(type, anchorName);

  return (
    <Container id={id}>
      {(title || subtitle) && (
        <TextContainer>
          {title && <Title>{title}</Title>}
          {subtitle && <StyledIntroText>{subtitle}</StyledIntroText>}
        </TextContainer>
      )}
      {children && (
        <HorizontalScrollWrapper childWidth={104}>
          {children}
        </HorizontalScrollWrapper>
      )}
    </Container>
  );
};

export default RowOfImagesWrapper;

const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: center;
  width: 100%;

  * {
    box-sizing: border-box;
  }
`;

const TextContainer = styled.div`
  margin-bottom: ${Spacings.XL};
  width: 100%;

  ${mq.from.breakpoint.M`
    margin-bottom: 60px;
  `}
`;

const Title = styled(ProductPageH2)`
  margin: 0;
  text-align: center;
  width: 100%;
`;

const StyledIntroText = styled(IntroText)`
  display: block;
  margin-top: ${Spacings.XS};
  text-align: center;

  ${mq.from.breakpoint.M`
    margin-top: ${Spacings.S};
  `}
`;
